import type { DiscoveredRouteModule } from '@/router/generator/types';

// Alias to support legacy links that use '/:projectId/register'
// Redirects to the canonical white label path '/register/:projectId'
export const route: DiscoveredRouteModule = {
  id: 'root.auth.register.alias',
  scope: 'root',
  name: 'RegisterAlias',
  path: '/:projectId/register',
  component: () => import('@/views/error-pages/NotFoundView.vue'), // not used due to redirect
  redirect: (to: any) => ({ path: `/register/${to.params.projectId}` }),
  meta: { isErrorPage: false, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true }
};


